
import httpRequest from '@/services/httpRequest.js'
import router from '@/router';
import notification from '@/services/notification.js';
import { Device } from '@capacitor/device';

let brand = null

try {
  brand = require('@/brand-config.json');
} catch (e) {
  console.warn('brand-config.json not found, using default')
}

export default ({
    namespaced: true,
    state: {
        errorLogin: null,
        isLoading: false,
        schoolData: brand || null,
        profileData: null,
        switchAccountState: null,
    },
    mutations: {
        async SET_USER_LOGIN(state, data) {
            let preferences = JSON.parse(localStorage.getItem('preferences'))

            //console.log('data = ', data.access)

            const base64Url = data.access.split('.')[1]
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
            const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=')
            const jsonPayload = await JSON.parse(decodeURIComponent(atob(padded).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')))
            let classroom = '';
            if (jsonPayload.role === 'prospective-guardian') {
                classroom = 'Calon Siswa';
            } else if (jsonPayload.role === 'guardian') {
                classroom = `Kelas ${jsonPayload.student.classroom}`;
            } else if (jsonPayload.role === 'student') {
                classroom = `Kelas ${jsonPayload.classroom}`;
            }

            const user = {
                id: jsonPayload.user_id,
                name: jsonPayload.role === 'guardian' || jsonPayload.role === 'prospective-guardian' ? jsonPayload.student.name : jsonPayload.name,
                photo: jsonPayload.photo,
                role: jsonPayload.role,
                isActive: true,
                classroom: classroom,
                auth: data
            }

            let school = { ...state.schoolData }
            school.isActive = true

            if (!preferences.schools) {
                school.users = [user]
                preferences.schools = [
                    school
                ]
            } else {
                let sameSchoolCodeIndex = -1
                let sameUserIndex = -1

                await preferences.schools.forEach((s) => {
                    if (s.isActive) {
                        s.isActive = false
                        if (s.users) {
                            s.users.forEach((u) => {
                                u.isActive = false
                            })
                        }
                    }

                    if (s.code === school.code) {
                        sameSchoolCodeIndex = preferences.schools.indexOf(s)
                        if (s.users) {
                            s.users.forEach((u, index) => {
                                if (u.id === user.id) {
                                    sameUserIndex = index
                                }
                            })
                        }
                    }
                })

                if (sameSchoolCodeIndex !== -1) {
                    if (sameUserIndex !== -1) {
                        preferences.schools[sameSchoolCodeIndex].isActive = true
                        preferences.schools[sameSchoolCodeIndex].users[sameUserIndex] = user
                    } else {
                        preferences.schools[sameSchoolCodeIndex].isActive = true
                        preferences.schools[sameSchoolCodeIndex].users.push(user)
                    }
                } else {
                    school.users = [user]
                    preferences.schools.push(school)
                }
            }

            localStorage.setItem('preferences', JSON.stringify(preferences))

            state.isLoading = false
            state.errorLogin = null
            await router.replace({ name: 'home' })

            window.history.pushState(null, '', window.location.href)
            window.addEventListener('popstate', () => {
                window.history.pushState(null, '', window.location.href)
            })
            
            window.location.reload()
        },

        async SET_LOG_OUT(state) {
            let preferences = JSON.parse(localStorage.getItem('preferences'))

            let totalSchools = preferences.schools.length;
            let noActiveSchool = false;
            let activeSchoolIndex = -1;
            let activeUserIndex = -1;
            let totalUsersInActiveSchool = -1;

            preferences.schools.forEach((school, schoolIndex) => {
                if (school.isActive) {
                    activeSchoolIndex = schoolIndex;
                    if (school.users) {
                        totalUsersInActiveSchool = school.users.length;
                        school.users.forEach( (user, userIndex) => {
                            if (user.isActive) {
                                activeUserIndex = userIndex;
                            }
                        });
                    }
                }
            });

            let res = null;

            const deviceInfo = await Device.getInfo()
            if (deviceInfo.platform !== 'web') {
                res = await notification.logout(preferences.schools[activeSchoolIndex].code, preferences.schools[activeSchoolIndex].users[activeUserIndex].role)
            }

            if (totalSchools < 2) {
                if (totalUsersInActiveSchool < 2) {
                    noActiveSchool = true;
                } else {
                    preferences.schools[activeSchoolIndex].users.splice(activeUserIndex, 1);
                    preferences.schools[activeSchoolIndex].users[0].isActive = true;
                }
            } else if (totalSchools >= 2) {
                if (totalUsersInActiveSchool < 2) {
                    preferences.schools.splice(activeSchoolIndex, 1);
                    preferences.schools[0].isActive = true;
                    preferences.schools[0].users[0].isActive = true;
                } else {
                    preferences.schools[activeSchoolIndex].users.splice(activeUserIndex, 1);
                    preferences.schools[activeSchoolIndex].users[0].isActive = true;
                }
            }

            if (noActiveSchool) {
                localStorage.removeItem('preferences')
            } else {
                localStorage.setItem('preferences', JSON.stringify(preferences))
            }

            state.isLoading = false
            state.errorLogin = null
            
            if (res) {
                await router.replace({ name: 'home' })
                window.location.reload()
            } else {
                if (deviceInfo.platform === 'web') {
                    await router.replace({ name: 'home' })
                    window.location.reload()
                }
            }

        },

        SWITCH_ACCOUNT(state, newUser) {
            const preferences = JSON.parse(localStorage.getItem('preferences'))
            preferences.schools.forEach((school) => {
                if (school.isActive) {
                    school.isActive = false
                    school.users.forEach((user) => {
                        user.isActive = false
                    })
                }

                if (school.code === newUser.schoolCode) {
                    school.isActive = true
                    if (school.users) {
                        school.users.forEach((user) => {
                            if (user.id === newUser.id) {
                                user.isActive = true
                            } else {
                                user.isActive = false
                            }
                        })
                    }
                }
            })
            localStorage.setItem('preferences', JSON.stringify(preferences))
        },
        async SET_PROFILE_DATA(state, data) {
            const localStorageUser = await JSON.parse(window.localStorage.getItem('preferences'))
            const user = await localStorageUser.schools.filter(school => school.isActive)[0].users.filter(user => user.isActive)[0]
            user.photo = data.photo
            user.role = data.role
            user.name = data.name
            window.localStorage.setItem('preferences', JSON.stringify(localStorageUser))
            state.profileData = data
        }
    },
    actions: {
        async login({ state, rootState, commit }, user) {
            const payload = {
                options: {
                    url: `${state.schoolData.domain}/api/token/`,
                    method: 'POST',
                    data: user
                },
                authorized: false
            }
            const res = await httpRequest(payload)
            //console.log('login res = ', res)

            if (res.status === 200) {
                commit('SET_USER_LOGIN', res.data)
            } else {
                state.isLoading = false
                //console.log('error = ', res)
                state.errorLogin = res.data.detail || 'Login failed'
            }
        },

        async switchAccount({ state, rootState, commit }, newUser) {
            commit('SWITCH_ACCOUNT', newUser)
            rootState.showSwitchAccount = false
            window.location.reload()
        },

        async getProfile({ state, rootState, commit }) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/profile`,
                    method: 'GET',
                },
                authorized: true
            }
            const res = await httpRequest(payload)
            if (res.status === 200) {
                //console.log('getProfile res = ', res)
                commit('SET_PROFILE_DATA', res.data)
            } else {
                //console.log('error = ', res)
            }

        },

        async logout({ commit }) {
            commit('SET_LOG_OUT')
        }
    },
})